// Civil Litigation Images
import civilimg1 from "../../assets/Services/civil-litigation/civil-1.jpg";
import civilimg2 from "../../assets/Services/civil-litigation/civil-2.jpg";
import civilimg3 from "../../assets/Services/civil-litigation/civil-3.jpg";
import civilimg4 from "../../assets/Services/civil-litigation/civil-4.jpg";
import civilimg5 from "../../assets/Services/civil-litigation/civil-5.jpg";
import civilimg6 from "../../assets/Services/civil-litigation/civil-6.jpg";
import civilimg7 from "../../assets/Services/civil-litigation/civil-7.jpg";
import civilimg8 from "../../assets/Services/civil-litigation/civil-8.jpg";

// Criminal Litigation Images
import criminalimg1 from "../../assets/Services/criminal-litigation/criminal-1.jpg";
import criminalimg2 from "../../assets/Services/criminal-litigation/criminal-2.jpg";
import criminalimg3 from "../../assets/Services/criminal-litigation/criminal-3.jpg";
import criminalimg4 from "../../assets/Services/criminal-litigation/criminal-4.jpg";
import criminalimg5 from "../../assets/Services/criminal-litigation/criminal-5.jpg";
import criminalimg6 from "../../assets/Services/criminal-litigation/criminal-6.jpg";
import criminalimg7 from "../../assets/Services/criminal-litigation/criminal-7.jpg";
import criminalimg8 from "../../assets/Services/criminal-litigation/criminal-8.jpg";

// Matrimonial Matters Images
import matrimonialimg1 from "../../assets/Services/matrimonial-matters/matrimonial-1.jpg";
import matrimonialimg2 from "../../assets/Services/matrimonial-matters/matrimonial-2.jpg";
import matrimonialimg3 from "../../assets/Services/matrimonial-matters/matrimonial-3.jpg";
import matrimonialimg4 from "../../assets/Services/matrimonial-matters/matrimonial-4.jpg";
import matrimonialimg5 from "../../assets/Services/matrimonial-matters/matrimonial-5.jpg";
import matrimonialimg6 from "../../assets/Services/matrimonial-matters/matrimonial-6.jpg";
import matrimonialimg7 from "../../assets/Services/matrimonial-matters/matrimonial-7.jpg";
import matrimonialimg8 from "../../assets/Services/matrimonial-matters/matrimonial-8.jpg";

// Commercial Matters Images
import commercialimg1 from "../../assets/Services/commercial-law/commercial-1.jpg";
import commercialimg2 from "../../assets/Services/commercial-law/commercial-2.jpg";
import commercialimg3 from "../../assets/Services/commercial-law/commercial-3.jpg";
import commercialimg4 from "../../assets/Services/commercial-law/commercial-4.jpg";
import commercialimg5 from "../../assets/Services/commercial-law/commercial-5.jpg";
import commercialimg6 from "../../assets/Services/commercial-law/commercial-6.jpg";
import commercialimg7 from "../../assets/Services/commercial-law/commercial-7.jpg";
import commercialimg8 from "../../assets/Services/commercial-law/commercial-8.jpg";

// RERA Matters Images
import reraimg1 from "../../assets/Services/rera-matters/rare-1.jpg";
import reraimg2 from "../../assets/Services/rera-matters/rare-2.jpg";
import reraimg3 from "../../assets/Services/rera-matters/rare-3.jpg";
import reraimg4 from "../../assets/Services/rera-matters/rare-4.jpg";
import reraimg5 from "../../assets/Services/rera-matters/rare-5.jpg";
import reraimg6 from "../../assets/Services/rera-matters/rare-6.jpg";
import reraimg7 from "../../assets/Services/rera-matters/rare-7.jpg";
import reraimg8 from "../../assets/Services/rera-matters/rare-8.jpg";

// Cheque Bounce Cases Images
import chequeimg1 from "../../assets/Services/cheque-bounce-cases/cheque-1.jpg";
import chequeimg2 from "../../assets/Services/cheque-bounce-cases/cheque-2.jpg";
import chequeimg3 from "../../assets/Services/cheque-bounce-cases/cheque-3.jpg";
import chequeimg4 from "../../assets/Services/cheque-bounce-cases/cheque-4.jpg";
import chequeimg5 from "../../assets/Services/cheque-bounce-cases/cheque-5.jpg";
import chequeimg6 from "../../assets/Services/cheque-bounce-cases/cheque-6.jpg";
import chequeimg7 from "../../assets/Services/cheque-bounce-cases/cheque-7.jpg";
import chequeimg8 from "../../assets/Services/cheque-bounce-cases/cheque-8.jpg";

// Constitutional Matters Images
import constitutionalimg1 from "../../assets/Services/constitutional-law/constitutional-1.jpg";
import constitutionalimg2 from "../../assets/Services/constitutional-law/constitutional-2.jpg";
import constitutionalimg3 from "../../assets/Services/constitutional-law/constitutional-3.jpg";
import constitutionalimg4 from "../../assets/Services/constitutional-law/constitutional-4.jpg";
import constitutionalimg5 from "../../assets/Services/constitutional-law/constitutional-5.jpg";
import constitutionalimg6 from "../../assets/Services/constitutional-law/constitutional-6.jpg";
import constitutionalimg7 from "../../assets/Services/constitutional-law/constitutional-7.jpg";
import constitutionalimg8 from "../../assets/Services/constitutional-law/constitutional-8.jpg";

// Banking & Finance Matters Images
import bankingimg1 from "../../assets/Services/banking-finance/banking-1.jpg";
import bankingimg2 from "../../assets/Services/banking-finance/banking-2.jpg";
import bankingimg3 from "../../assets/Services/banking-finance/banking-3.jpg";
import bankingimg4 from "../../assets/Services/banking-finance/banking-4.jpg";
import bankingimg5 from "../../assets/Services/banking-finance/banking-5.jpg";
import bankingimg6 from "../../assets/Services/banking-finance/banking-6.jpg";
import bankingimg7 from "../../assets/Services/banking-finance/banking-7.jpg";
import bankingimg8 from "../../assets/Services/banking-finance/banking-8.jpg";

// IBC Matters Images
import ibcimg1 from "../../assets/Services/ibc-matters/ibc-1.jpg";
import ibcimg2 from "../../assets/Services/ibc-matters/ibc-2.jpg";
import ibcimg3 from "../../assets/Services/ibc-matters/ibc-3.jpg";
import ibcimg4 from "../../assets/Services/ibc-matters/ibc-4.jpg";
import ibcimg5 from "../../assets/Services/ibc-matters/ibc-5.jpg";
import ibcimg6 from "../../assets/Services/ibc-matters/ibc-6.jpg";
import ibcimg7 from "../../assets/Services/ibc-matters/ibc-7.jpg";
import ibcimg8 from "../../assets/Services/ibc-matters/ibc-8.jpg";

// Cyber Matters Images
import cyberimg1 from "../../assets/Services/cyber-matters/cyber-1.jpg";
import cyberimg2 from "../../assets/Services/cyber-matters/cyber-2.jpg";
import cyberimg3 from "../../assets/Services/cyber-matters/cyber-3.jpg";
import cyberimg4 from "../../assets/Services/cyber-matters/cyber-4.jpg";
import cyberimg5 from "../../assets/Services/cyber-matters/cyber-5.jpg";
import cyberimg6 from "../../assets/Services/cyber-matters/cyber-6.jpg";
import cyberimg7 from "../../assets/Services/cyber-matters/cyber-7.jpg";
import cyberimg8 from "../../assets/Services/cyber-matters/cyber-8.jpg";

// Environmental Matters Images
import envimg1 from "../../assets/Services/environmental-matters/envirment-1.jpg";
import envimg2 from "../../assets/Services/environmental-matters/envirment-2.jpg";
import envimg3 from "../../assets/Services/environmental-matters/envirment-3.jpg";
import envimg4 from "../../assets/Services/environmental-matters/envirment-4.jpg";
import envimg5 from "../../assets/Services/environmental-matters/envirment-5.jpg";
import envimg6 from "../../assets/Services/environmental-matters/envirment-6.jpg";
import envimg7 from "../../assets/Services/environmental-matters/envirment-7.jpg";
import envimg8 from "../../assets/Services/environmental-matters/envirment-8.jpg";

// Arbitration & Mediation Images
import arbimg1 from "../../assets/Services/arbitration-mediation/arbitration-1.jpg";
import arbimg2 from "../../assets/Services/arbitration-mediation/arbitration-2.jpg";
import arbimg3 from "../../assets/Services/arbitration-mediation/arbitration-3.jpg";
import arbimg4 from "../../assets/Services/arbitration-mediation/arbitration-4.jpg";
import arbimg5 from "../../assets/Services/arbitration-mediation/arbitration-5.jpg";
import arbimg6 from "../../assets/Services/arbitration-mediation/arbitration-6.jpg";
import arbimg7 from "../../assets/Services/arbitration-mediation/arbitration-7.jpg";
import arbimg8 from "../../assets/Services/arbitration-mediation/arbitration-8.jpg";

// Company Matters Images
import cpimg1 from "../../assets/Services/company-matters/company-1.jpg";
import cpimg2 from "../../assets/Services/company-matters/company-2.jpg";
import cpimg3 from "../../assets/Services/company-matters/company-3.jpg";
import cpimg4 from "../../assets/Services/company-matters/company-4.jpg";
import cpimg5 from "../../assets/Services/company-matters/company-5.jpg";
import cpimg6 from "../../assets/Services/company-matters/company-6.jpg";
import cpimg7 from "../../assets/Services/company-matters/company-7.jpg";
import cpimg8 from "../../assets/Services/company-matters/company-8.jpg";

// Human Rights / PILs Images
import humanimg1 from "../../assets/Services/human-rights-pils/humanright-1.jpg";
import humanimg2 from "../../assets/Services/human-rights-pils/humanright-2.jpg";
import humanimg3 from "../../assets/Services/human-rights-pils/humanright-3.jpg";
import humanimg4 from "../../assets/Services/human-rights-pils/humanright-4.jpg";
import humanimg5 from "../../assets/Services/human-rights-pils/humanright-5.jpg";
import humanimg6 from "../../assets/Services/human-rights-pils/humanright-6.jpg";
import humanimg7 from "../../assets/Services/human-rights-pils/humanright-7.jpg";
import humanimg8 from "../../assets/Services/human-rights-pils/humanright-8.jpg";

export const servicesData = [
  {
    id: "criminal-cases",

    title: "Criminal Cases",

    bannerImage: criminalimg2,

    shortDesc:
      "Expert defense in bail matters, criminal trials  and white-collar crimes with strategic legal representation.",

    fullDesc: {
      intro:
        "We provide comprehensive criminal litigation services focused on protecting the rights  and liberty of our clients. From pre-arrest protection to trial  and appellate advocacy, our team ensures a strong, strategic  and result-driven defense at every stage of the criminal justice process.",

      sections: [
        {
          title: "Our Legal Expertise",
          content:
            "Our criminal law practice covers a wide range of offenses under the Indian Penal Code  and special laws. We represent clients in bail matters, trial proceedings  and appeals while ensuring procedural safeguards  and legal rights are strictly upheld. Our approach combines legal precision with practical courtroom strategy.",
        },

        {
          title: "Bail & Pre-Arrest Protection",
          list: [
            "Regular bail applications in trial  and sessions courts",
            "Anticipatory bail for protection against arrest",
            "Urgent bail hearings  and interim relief",
            "H andling non-bailable offences effectively",
            "Legal strategy for bail rejection cases",
          ],
        },

        {
          title: "Trial & Court Representation",
          list: [
            "Comprehensive defense in criminal trials",
            "Cross-examination  and evidence h andling",
            "Representation before Magistrate  and Sessions Courts",
            "Strategic case building  and argument drafting",
            "Protection of constitutional  and legal rights",
          ],
        },

        {
          title: "High Court & Appellate Matters",
          list: [
            "FIR quashing petitions under Section 482 CrPC",
            "Criminal appeals against conviction or sentencing",
            "Revision petitions  and legal challenges",
            "Representation in High Court  and Supreme Court",
            "Stay orders  and interim relief applications",
          ],
        },

        {
          title: "Specialized Criminal Matters",
          list: [
            "White-collar crimes  and financial fraud cases",
            "Cybercrime cases including hacking  and data theft",
            "Corporate criminal liability matters",
            "Economic offences  and investigation support",
            "Legal defense in complex multi-agency cases",
          ],
        },

        {
          title: "Our Approach",
          list: [
            "Confidential case assessment  and consultation",
            "Detailed evidence review  and legal strategy",
            "Pre-arrest  and post-arrest legal planning",
            "Aggressive  and strategic court representation",
            "Regular updates  and transparent communication",
            "Final resolution  and appellate support if required",
          ],
        },

        {
          title: "Why Choose Us",
          content:
            "We underst and the sensitivity  and urgency of criminal matters. Our team ensures quick action, confidentiality  and strong courtroom advocacy. With a focus on protecting individual rights  and achieving the best possible outcomes, we provide reliable  and result-oriented criminal defense services.",
        },

        {
          title: "Clients We Represent",
          list: [
            "Individuals facing criminal charges",
            "Corporate professionals  and executives",
            "Business owners  and entrepreneurs",
            "Startups  and organizations",
            "Clients in high-stakes  and sensitive matters",
          ],
        },
      ],
    },

    icon: "🏛️",

    featureDetails: [
      {
        name: "Regular Bail",
        img: criminalimg1,
        desc: "Representation for securing release during investigation or trial. We ensure timely filing  and strong legal arguments for bail approval.",
      },
      {
        name: "Anticipatory Bail",
        img: criminalimg2,
        desc: "Legal protection against potential arrest in non-bailable offences. Our team prepares proactive strategies to safeguard your liberty.",
      },
      {
        name: "Trial Advocacy",
        img: criminalimg3,
        desc: "Comprehensive defense throughout the criminal trial process. We h andle evidence, arguments  and courtroom strategy effectively.",
      },
      {
        name: "FIR Quashing",
        img: criminalimg4,
        desc: "Petitions before High Courts to quash meritless criminal proceedings. We ensure misuse of law is challenged legally.",
      },
      {
        name: "Criminal Appeals",
        img: criminalimg5,
        desc: "Challenging convictions in Sessions, High Courts & Supreme Court. We focus on reversing unjust decisions through strong legal grounds.",
      },
      {
        name: "White Collar Crimes",
        img: criminalimg6,
        desc: "H andling complex corporate fraud  and financial investigations. We provide strategic defense in high-value cases.",
      },
      {
        name: "Cyber Crimes",
        img: criminalimg7,
        desc: "Defense in matters of data theft, hacking  and online fraud. We h andle modern digital crime cases with technical underst anding.",
      },
      {
        name: "Police Custody Help",
        img: criminalimg8,
        desc: "Legal assistance during police interrogation  and custody. We ensure your rights are protected at every stage.",
      },
    ],

    helmetTitle: "Criminal Cases Lawyers in Delhi NCR | Legal Experts",

    helmetDescription:
      "R & P Law Partners provides expert legal assistance for Criminal Cases in Delhi NCR, offering strategic defense, bail, FIR, trial, and appellate representation.",

    helmetKeywords:
      "Criminal Cases",

    helmetnoscript:
      "Please enable JavaScript to view this Criminal Litigation service page properly.",
  },
  {
    id: "civil-cases",

    title: "Civil Cases",

    bannerImage: civilimg2,

    shortDesc:
      "Expert h andling of property disputes, contract enforcement  and consumer rights with strategic legal solutions.",

    fullDesc: {
      intro:
        "We provide comprehensive civil litigation services tailored to address a wide range of legal disputes with precision, strategy  and dedication. Our team focuses on delivering practical  and result-oriented legal solutions while ensuring complete transparency  and client satisfaction throughout the legal process.",

      sections: [
        {
          title: "Our Legal Expertise",
          content:
            "Our expertise covers property disputes, where we assist clients in resolving ownership conflicts, title issues  and boundary disagreements through effective legal strategies. We also h andle injunction matters, ensuring timely relief to protect our clients’ rights  and interests. With a strong underst anding of civil laws, we aim to minimize risks  and deliver efficient outcomes.",
        },

        {
          title: "Financial & Property Matters",
          list: [
            "Recovery suits for outst anding dues  and financial claims",
            "Partition suits for division of jointly owned property",
            "Execution petitions to enforce court decrees effectively",
            "H andling ownership conflicts  and title disputes",
            "Legal due diligence for property transactions",
            "Advisory on l and acquisition  and property investments",
          ],
        },

        {
          title: "Contract & Legal Enforcement",
          list: [
            "Specific performance cases to enforce agreements",
            "Legal action for breach of contract",
            "Ensuring contractual obligations are fulfilled",
            "Strategic legal representation in disputes",
            "Drafting  and reviewing legal contracts",
            "Negotiation  and dispute resolution support",
          ],
        },

        {
          title: "Rental & Consumer Protection",
          list: [
            "Rent  and eviction disputes for l andlords  and tenants",
            "Legal assistance in tenancy agreements",
            "Consumer protection cases for unfair practices",
            "Compensation claims for service deficiencies",
            "Representation before consumer forums",
            "H andling builder-buyer disputes  and delays",
          ],
        },

        {
          title: "Our Approach",
          list: [
            "Initial consultation  and case underst anding",
            "Detailed case evaluation  and documentation",
            "Legal notice drafting  and pre-litigation strategy",
            "Filing  and legal proceedings",
            "Strong court representation",
            "Continuous case updates  and client communication",
            "Final resolution  and enforcement",
          ],
        },

        {
          title: "Why Choose Us",
          content:
            "We combine legal expertise with a client-centric approach to deliver reliable  and effective solutions. Our team ensures timely communication, strategic planning  and strong courtroom representation. We prioritize ethical practices, confidentiality  and a results-driven methodology to achieve the best possible outcomes for our clients.",
        },

        {
          title: "Industries We Serve",
          list: [
            "Real estate  and property sector",
            "Small  and medium enterprises (SMEs)",
            "Corporate  and business entities",
            "Individual clients  and families",
            "Startups  and entrepreneurs",
          ],
        },
      ],
    },

    icon: "⚖️",

    featureDetails: [
      {
        name: "Property Disputes",
        img: civilimg1,
        desc: "Expert h andling of l and ownership  and title deed conflicts. We ensure proper legal resolution through thorough documentation  and representation.",
      },
      {
        name: "Injunctions",
        img: civilimg2,
        desc: "Securing immediate court orders to prevent illegal actions. Our team acts quickly to safeguard your rights  and interests.",
      },
      {
        name: "Recovery Suits",
        img: civilimg3,
        desc: "Legal action for recovery of outst anding debts  and dues. We follow a strategic approach to ensure timely  and effective recovery.",
      },
      {
        name: "Partition Suits",
        img: civilimg4,
        desc: "Legal division of ancestral or joint properties among heirs. We h andle disputes carefully to achieve fair  and lawful distribution.",
      },
      {
        name: "Specific Performance",
        img: civilimg5,
        desc: "Enforcing contractual obligations through court m andates. We ensure agreements are honored as per legal provisions.",
      },
      {
        name: "Rent & Eviction",
        img: civilimg6,
        desc: "Resolving l andlord-tenant disputes  and eviction processes. We provide balanced legal support for both parties involved.",
      },
      {
        name: "Consumer Law",
        img: civilimg7,
        desc: "Protecting rights against unfair trade practices  and services. We help clients seek compensation  and justice effectively.",
      },
      {
        name: "Execution Petitions",
        img: civilimg8,
        desc: "Implementing court decrees to ensure justice is served. Our team ensures proper enforcement without unnecessary delays.",
      },
    ],

    helmetTitle: "Civil Cases Lawyers in Delhi NCR | Legal Solutions",

    helmetDescription:
      "R & P Law Partners offers trusted legal services for Civil Cases in Delhi NCR, including property disputes, recovery suits, injunctions, and civil litigation.",

    helmetKeywords:
      "Civil Cases",

    helmetnoscript:
      "Please enable JavaScript to view this Civil Litigation service page properly.",
  },
  {
    id: "matrimonial-cases",

    title: "Matrimonial Cases",

    bannerImage: matrimonialimg3,

    shortDesc:
      "Sensitive h andling of divorce, child custody  and family disputes with a compassionate  and strategic legal approach.",

    fullDesc: {
      intro:
        "We provide comprehensive matrimonial  and family law services with a focus on sensitivity, confidentiality  and practical solutions. Underst anding the emotional  and legal complexities involved, our team ensures a balanced approach to protect your rights while aiming for fair  and amicable resolutions wherever possible.",

      sections: [
        {
          title: "Our Legal Expertise",
          content:
            "Our matrimonial practice covers divorce, maintenance, child custody  and domestic violence matters. We h andle both mutual  and contested cases with a strong legal strategy while ensuring minimal emotional stress for our clients. Our goal is to secure fair outcomes while maintaining dignity  and confidentiality.",
        },

        {
          title: "Divorce & Separation Matters",
          list: [
            "Mutual consent divorce with fast-track resolution",
            "Contested divorce cases with strong representation",
            "Judicial separation  and legal notices",
            "Drafting  and filing of divorce petitions",
            "H andling complex marital disputes  and litigation",
          ],
        },

        {
          title: "Child Custody & Family Rights",
          list: [
            "Child custody  and visitation rights cases",
            "Ensuring welfare  and best interests of the child",
            "Guardianship  and parental rights matters",
            "Modification of custody arrangements",
            "Negotiation  and mediation in family disputes",
          ],
        },

        {
          title: "Maintenance & Financial Matters",
          list: [
            "Maintenance cases under Section 125 CrPC",
            "Alimony  and financial settlement negotiations",
            "Interim maintenance applications",
            "Enforcement of maintenance orders",
            "Financial rights protection for spouses",
          ],
        },

        {
          title: "Protection & Legal Remedies",
          list: [
            "Domestic violence cases under DV Act",
            "Protection orders  and residence rights",
            "Dowry harassment  and cruelty cases",
            "Filing complaints  and legal defense",
            "Immediate legal relief in urgent situations",
          ],
        },

        {
          title: "Our Approach",
          list: [
            "Confidential consultation  and case underst anding",
            "Emotional  and legal support throughout the process",
            "Strategic legal planning  and documentation",
            "Encouraging mediation  and settlement where possible",
            "Strong courtroom representation when required",
            "Timely updates  and transparent communication",
          ],
        },

        {
          title: "Why Choose Us",
          content:
            "We underst and that matrimonial disputes are deeply personal  and emotionally challenging. Our team ensures a compassionate approach combined with strong legal expertise. We focus on protecting your rights, maintaining confidentiality  and achieving fair  and practical outcomes.",
        },

        {
          title: "Who We Help",
          list: [
            "Individuals seeking divorce or separation",
            "Parents involved in custody disputes",
            "Spouses seeking maintenance or alimony",
            "Victims of domestic violence or harassment",
            "Families seeking peaceful dispute resolution",
          ],
        },
      ],
    },

    icon: "🏠",

    featureDetails: [
      {
        name: "Mutual Divorce",
        img: matrimonialimg1,
        desc: "Fast-track dissolution of marriage with mutual agreement. We ensure smooth documentation  and minimal legal complications.",
      },
      {
        name: "Contested Divorce",
        img: matrimonialimg2,
        desc: "Strong representation in complex disputed divorce cases. We build strategic arguments to protect your rights.",
      },
      {
        name: "Child Custody",
        img: matrimonialimg3,
        desc: "Protecting parental rights  and ensuring the child's welfare. We prioritize the best interests of the child.",
      },
      {
        name: "Alimony Matters",
        img: matrimonialimg4,
        desc: "Legal support for fair financial maintenance  and settlements. We ensure equitable outcomes for both parties.",
      },
      {
        name: "Domestic Violence",
        img: matrimonialimg5,
        desc: "Protection orders  and litigation under the DV Act. We provide immediate legal relief  and strong representation.",
      },
      {
        name: "Annulment",
        img: matrimonialimg6,
        desc: "Legal petitions for declaring a marriage null  and void. We h andle cases with sensitivity  and legal precision.",
      },
      {
        name: "Restitution of Rights",
        img: matrimonialimg7,
        desc: "Legal steps for the reconciliation of separated spouses. We guide clients through lawful restoration processes.",
      },
      {
        name: "Family Counseling",
        img: matrimonialimg8,
        desc: "Mediation services to resolve family disputes amicably. We aim to reduce conflict through structured discussions.",
      },
    ],

    helmetTitle:
      "Matrimonial Cases Lawyers in Delhi NCR | Family Law",

    helmetDescription:
      "R & P Law Partners handles Matrimonial Cases in Delhi NCR with expert legal support for divorce, child custody, maintenance, and domestic violence matters.",

    helmetKeywords:
      "Matrimonial Cases",

    helmetnoscript:
      "Please enable JavaScript to view this Matrimonial Matters service page properly.",
  },
  {
    id: "immigration-law",
    title: "Immigration Law",
    bannerImage: commercialimg2,
    shortDesc:
      "Professional legal assistance for visas, immigration, citizenship  and residency matters.",
    fullDesc: {
      intro:
        "We provide comprehensive legal support for individuals, families  and businesses navigating immigration laws. Our services include visa applications, work permits, permanent residency, citizenship matters, deportation defense  and immigration compliance.",

      sections: [
        {
          title: "Our Legal Expertise",
          content:
            "Our immigration law practice assists clients with visas, residency, citizenship  and compliance matters. We provide strategic legal guidance to ensure smooth immigration processes  and legal protection.",
        },

        {
          title: "Visa & Entry Services",
          list: [
            "Tourist visa applications",
            "Student visa assistance",
            "Business visa support",
            "Work visa processing",
            "Visa renewals  and extensions",
          ],
        },

        {
          title: "Work Permits & Employment",
          list: [
            "Employment authorization",
            "Work permit applications",
            "Employer sponsorship support",
            "Skilled worker programs",
            "Professional immigration guidance",
          ],
        },

        {
          title: "Residency & Citizenship",
          list: [
            "Permanent residency applications",
            "Settlement programs",
            "Naturalization assistance",
            "Citizenship applications",
            "Residency renewals",
          ],
        },

        {
          title: "Family Immigration",
          list: [
            "Family sponsorship",
            "Spouse visa applications",
            "Dependent visa services",
            "Family reunification matters",
            "Immigration documentation support",
          ],
        },

        {
          title: "Deportation & Appeals",
          list: [
            "Removal proceedings defense",
            "Deportation case representation",
            "Immigration appeals",
            "Legal review of immigration decisions",
            "Protection of immigration rights",
          ],
        },

        {
          title: "Why Choose Us",
          content:
            "Our team provides reliable immigration law services with personalized guidance, accurate documentatio  and strong legal representation to help clients achieve their immigration goals.",
        },
      ],
    },
    icon: "✈️",
    featureDetails: [
      {
        name: "Visa Applications",
        img: commercialimg1,
        desc: "Assistance with tourist, student, work  and business visa applications.",
      },
      {
        name: "Work Permits",
        img: commercialimg2,
        desc: "Legal guidance for obtaining employment  and work authorization permits.",
      },
      {
        name: "Permanent Residency",
        img: commercialimg3,
        desc: "Support for residency applications  and settlement programs.",
      },
      {
        name: "Citizenship Services",
        img: commercialimg4,
        desc: "Helping clients with naturalization  and citizenship applications.",
      },
      {
        name: "Family Immigration",
        img: commercialimg5,
        desc: "Assistance with family sponsorship  and reunification processes.",
      },
      {
        name: "Deportation Defense",
        img: commercialimg6,
        desc: "Representation in removal, deportation  and immigration appeal cases.",
      },
      {
        name: "Business Immigration",
        img: commercialimg7,
        desc: "Legal support for investor visas, entrepreneurs  and corporate immigration.",
      },
      {
        name: "Immigration Compliance",
        img: commercialimg8,
        desc: "Ensuring compliance with immigration regulations  and documentation requirements.",
      },
    ],
    helmetTitle: "Immigration Law Services in Delhi NCR | Visa Experts",
    helmetDescription:
      "R & P Law Partners provides professional Immigration Law services in Delhi NCR for visas, OCI, documentation, appeals, and legal immigration guidance.",
    helmetKeywords:
      "Immigration Law",
    helmetnoscript:
      "Please enable JavaScript to view this Immigration Law service page properly.",
  },
  {
    id: "company-related-issue",

    title: "Company Related Issue",

    bannerImage: cpimg3,

    shortDesc:
      "Comprehensive legal services for corporate compliance, governance, disputes  and business structuring.",

    fullDesc: {
      intro:
        "We provide end-to-end legal solutions for company-related matters, helping businesses operate smoothly while ensuring full legal compliance. Our team offers strategic advice  and strong representation in corporate governance, disputes  and regulatory issues.",

      sections: [
        {
          title: "Our Legal Expertise",
          content:
            "Our practice covers all aspects of company law, including incorporation, compliance, shareholder disputes  and corporate restructuring. We assist businesses at every stage, from formation to expansion  and dispute resolution, ensuring legal stability  and growth.",
        },

        {
          title: "Company Formation & Structuring",
          list: [
            "Incorporation of Private Limited, LLP  and OPC companies",
            "Drafting MoA, AoA  and Teamhip agreements",
            "Business structure advisory  and legal setup",
            "Registration  and licensing procedures",
            "Startup legal support  and compliance",
          ],
        },

        {
          title: "Corporate Compliance & Governance",
          list: [
            "ROC filings  and annual compliance management",
            "Maintaining statutory registers  and records",
            "Secretarial audits  and compliance checks",
            "Advisory on Companies Act provisions",
            "Corporate governance  and policy drafting",
          ],
        },

        {
          title: "Disputes & Litigation",
          list: [
            "Shareholder  and Teamhip disputes",
            "Mismanagement  and oppression cases",
            "Director liability  and fiduciary duties",
            "Representation before NCLT  and courts",
            "Legal notices  and dispute resolution strategies",
          ],
        },

        {
          title: "Mergers, Acquisitions & Restructuring",
          list: [
            "M&A due diligence  and legal risk assessment",
            "Drafting  and reviewing transaction documents",
            "Business restructuring  and joint ventures",
            "Compliance in mergers  and acquisitions",
            "Advisory on corporate expansion strategies",
          ],
        },

        {
          title: "Closure & Exit Management",
          list: [
            "Company winding up  and dissolution",
            "Strike-off procedures  and compliance",
            "Exit strategies for directors  and shareholders",
            "Settlement of liabilities  and assets",
            "Legal documentation for closure",
          ],
        },

        {
          title: "Our Approach",
          list: [
            "Underst anding business requirements  and risks",
            "Detailed legal  and compliance assessment",
            "Strategic planning  and documentation",
            "Proactive compliance management",
            "Strong representation in disputes",
            "Ensuring smooth business operations",
          ],
        },

        {
          title: "Why Choose Us",
          content:
            "We combine legal expertise with business underst anding to provide practical  and effective solutions. Our focus is on minimizing legal risks, ensuring compliance  and supporting business growth through reliable legal strategies.",
        },

        {
          title: "Who We Help",
          list: [
            "Startups  and entrepreneurs",
            "Small  and medium enterprises (SMEs)",
            "Corporate entities  and companies",
            "Directors  and shareholders",
            "Investors  and business Team",
          ],
        },
      ],
    },

    icon: "🏢",

    featureDetails: [
      {
        name: "Incorporation",
        img: cpimg1,
        desc: "Formation of Private Limited, LLP  and OPC companies. We ensure smooth  and compliant business setup.",
      },
      {
        name: "ROC Compliance",
        img: cpimg2,
        desc: "Managing annual filings  and statutory records. We keep your company fully compliant.",
      },
      {
        name: "Shareholder Rights",
        img: cpimg3,
        desc: "Legal representation in internal company conflicts. We protect stakeholder interests effectively.",
      },
      {
        name: "M&A Due Diligence",
        img: cpimg4,
        desc: "Evaluating legal risks in mergers  and acquisitions. We ensure safe  and informed business decisions.",
      },
      {
        name: "Company Winding Up",
        img: cpimg5,
        desc: "Assisting in legal closure  and dissolution. We h andle compliance  and documentation smoothly.",
      },
      {
        name: "Director Liability",
        img: cpimg6,
        desc: "Advisory on directors' duties  and liabilities. We ensure legal protection  and compliance.",
      },
      {
        name: "Secretarial Audit",
        img: cpimg7,
        desc: "Ensuring company records meet statutory requirements. We identify  and fix compliance gaps.",
      },
      {
        name: "MoA & AoA Drafting",
        img: cpimg8,
        desc: "Drafting charter documents for companies. We ensure strong legal foundations for your business.",
      },
    ],

    helmetTitle:
      "Company Related Issue Lawyers in Delhi NCR | R & P Law",

    helmetDescription:
      "R & P Law Partners delivers expert legal solutions for Company Related Issue matters in Delhi NCR, including compliance, contracts, and corporate advisory.",

    helmetKeywords:
      "Company Related Issue",

    helmetnoscript:
      "Please enable JavaScript to view this Company Related Issue service page properly.",
  },
  {
    id: "commercial-disputes",
    title: "Commercial Disputes",
    bannerImage: commercialimg3,

    shortDesc:
      "Specialized legal services for business conflicts, partnership disputes, debt recovery and contract enforcement.",

    fullDesc: {
      intro:
        "We provide expert legal guidance  and representation in commercial disputes, helping businesses resolve conflicts efficiently  and protect their commercial interests. Our services cover contract disputes, partnership disagreements, debt recovery, shareholder conflicts, corporate governance issues and business litigation.",

      sections: [
        {
          title: "Our Legal Expertise",
          content:
            "Our commercial dispute practice focuses on resolving complex business conflicts through strategic legal solutions. We assist companies, entrepreneurs and business partners in protecting their rights  and achieving favorable outcomes through litigation, arbitration, mediation and negotiation.",
        },

        {
          title: "Contract Disputes",
          list: [
            "Breach of contract claims",
            "Commercial agreement disputes",
            "Contract enforcement actions",
            "Drafting  and reviewing legal notices",
            "Settlement  and dispute resolution",
          ],
        },

        {
          title: "Debt Recovery & Financial Claims",
          list: [
            "Recovery of outst anding business dues",
            "Debt collection proceedings",
            "Cheque bounce matters",
            "Financial claim enforcement",
            "Negotiated settlements  and recoveries",
          ],
        },

        {
          title: "Partnership & Shareholder Disputes",
          list: [
            "Partnership disagreements  and dissolution",
            "Shareholder conflicts  and rights protection",
            "Business ownership disputes",
            "Profit-sharing disagreements",
            "Corporate governance issues",
          ],
        },

        {
          title: "Corporate & Company Matters",
          list: [
            "Company law compliance",
            "Director  and management disputes",
            "Corporate restructuring issues",
            "Business regulatory matters",
            "Internal company conflicts",
          ],
        },

        {
          title: "NCLT Representation",
          list: [
            "Representation before NCLT",
            "Corporate insolvency matters",
            "Company petitions  and applications",
            "Shareholder  and oppression disputes",
            "Corporate litigation support",
          ],
        },

        {
          title: "Intellectual Property Protection",
          list: [
            "Trademark dispute resolution",
            "Copyright infringement matters",
            "Patent protection issues",
            "Br and protection strategies",
            "IP litigation  and enforcement",
          ],
        },

        {
          title: "Why Choose Us",
          content:
            "Our legal team combines commercial awareness with strong litigation experience to deliver practical  and effective solutions. We focus on minimizing business disruption while protecting our clients' financial  and legal interests through professional representation  and strategic advice.",
        },

        {
          title: "Who We Help",
          list: [
            "Business owners  and entrepreneurs",
            "Partnership firms  and LLPs",
            "Private  and public companies",
            "Directors  and shareholders",
            "Startups  and growing enterprises",
          ],
        },
      ],
    },
    icon: "💼",

    featureDetails: [
      {
        name: "Contract Disputes",
        img: commercialimg1,
        desc: "Resolving breaches of business contracts  and commercial agreements efficiently.",
      },
      {
        name: "Recovery of Money",
        img: commercialimg2,
        desc: "Legal assistance for recovering outst anding payments  and business dues.",
      },
      {
        name: "Partnership Disputes",
        img: commercialimg3,
        desc: "H andling conflicts between business partners with strategic legal solutions.",
      },
      {
        name: "Company Related Issues",
        img: commercialimg4,
        desc: "Addressing corporate disputes, governance matters and regulatory compliance.",
      },
      {
        name: "NCLT Representation",
        img: commercialimg5,
        desc: "Representation before the National Company Law Tribunal in corporate matters.",
      },
      {
        name: "Intellectual Property",
        img: commercialimg6,
        desc: "Protecting trademarks, copyrights, patents and other intellectual property rights.",
      },
      {
        name: "Compliance Audit",
        img: commercialimg7,
        desc: "Ensuring statutory  and regulatory compliance across business operations.",
      },
      {
        name: "Trade Secrets Protection",
        img: commercialimg8,
        desc: "Safeguarding confidential business information  and proprietary assets.",
      },
    ],

    helmetTitle:
      "Commercial Disputes Lawyers in Delhi NCR | R & P Law",

    helmetDescription:
      "Resolve Commercial Disputes confidently with R & P Law Partners, offering business litigation, arbitration, and legal advisory across Delhi NCR.",

    helmetKeywords:
      "Commercial Disputes",

    helmetnoscript:
      "Please enable JavaScript to view this Commercial Disputes service page properly.",
  },
  {
    id: "cyber-cases",

    title: "Cyber Crime",

    bannerImage: cyberimg2,

    shortDesc:
      "Expert legal services in cybercrime, data protection and digital fraud with strong technical  and legal expertise.",

    fullDesc: {
      intro:
        "We provide comprehensive legal services in cyber law, addressing the growing challenges of digital crimes  and data protection. Our team h andles complex cyber disputes with a combination of legal expertise  and technical underst anding, ensuring effective protection  and enforcement of rights.",

      sections: [
        {
          title: "Our Legal Expertise",
          content:
            "Our cyber law practice covers offenses under the Information Technology Act  and related laws. We assist clients in matters such as online fraud, data breaches, cyber defamation and digital privacy violations, ensuring strong legal protection  and timely action.",
        },

        {
          title: "Cybercrime & Digital Offenses",
          list: [
            "Cases related to data theft  and unauthorized access",
            "Online fraud including phishing  and financial scams",
            "Identity theft  and impersonation cases",
            "Cyber stalking  and harassment matters",
            "Filing cybercrime complaints  and FIRs",
          ],
        },

        {
          title: "IT Act & Legal Compliance",
          list: [
            "Defense under various provisions of the IT Act",
            "Advisory on cyber law compliance",
            "H andling digital evidence  and investigations",
            "Legal notices  and regulatory actions",
            "Representation before cybercrime authorities",
          ],
        },

        {
          title: "Data Protection & Privacy",
          list: [
            "Data breach response  and legal action",
            "Privacy law compliance for organizations",
            "Advisory on data protection frameworks",
            "H andling misuse of personal information",
            "Cross-border data protection issues",
          ],
        },

        {
          title: "E-Commerce & Digital Business",
          list: [
            "Legal compliance for online businesses",
            "Drafting website terms  and privacy policies",
            "Dispute resolution in e-commerce transactions",
            "Consumer complaints in digital platforms",
            "Protection of digital assets  and IP",
          ],
        },

        {
          title: "Our Approach",
          list: [
            "Underst anding technical  and legal aspects",
            "Detailed case evaluation  and evidence review",
            "Strategic legal planning  and documentation",
            "Coordination with cybercrime authorities",
            "Strong representation in legal proceedings",
            "Ensuring quick  and effective resolution",
          ],
        },

        {
          title: "Why Choose Us",
          content:
            "We combine legal knowledge with technological insight to h andle cyber matters effectively. Our team ensures quick response, strong legal strategy and complete confidentiality while protecting your digital rights.",
        },

        {
          title: "Who We Help",
          list: [
            "Individuals affected by cybercrime",
            "Businesses facing data breaches",
            "E-commerce platforms  and startups",
            "Corporate organizations",
            "Clients requiring IT law compliance",
          ],
        },
      ],
    },

    icon: "💻",

    featureDetails: [
      {
        name: "Data Theft",
        img: cyberimg1,
        desc: "Litigation against unauthorized data access  and theft. We ensure strong legal action  and recovery measures.",
      },
      {
        name: "Online Fraud",
        img: cyberimg2,
        desc: "Legal action against phishing, scams and financial fraud. We help recover losses  and prosecute offenders.",
      },
      {
        name: "Cyber Defamation",
        img: cyberimg3,
        desc: "H andling online reputation damage cases. We take swift action to remove harmful content.",
      },
      {
        name: "IT Act Violations",
        img: cyberimg4,
        desc: "Defense  and prosecution under IT Act provisions. We ensure proper legal compliance  and representation.",
      },
      {
        name: "Digital Signatures",
        img: cyberimg5,
        desc: "Resolving disputes related to e-signatures. We ensure authenticity  and legal protection.",
      },
      {
        name: "E-Commerce Law",
        img: cyberimg6,
        desc: "Legal compliance for online businesses. We help manage risks in digital transactions.",
      },
      {
        name: "Privacy Compliance",
        img: cyberimg7,
        desc: "Ensuring adherence to data protection laws. We safeguard organizational  and personal data.",
      },
      {
        name: "Identity Theft",
        img: cyberimg8,
        desc: "Legal action against misuse of identity online. We protect your digital identity  and rights.",
      },
    ],

    helmetTitle:
      "Cyber Cases Lawyers in Delhi NCR | Cyber Law Experts",

    helmetDescription:
      "R & P Law Partners provides expert legal representation for Cyber Cases in Delhi NCR, including cybercrime, online fraud, hacking, and digital privacy matters.",

    helmetKeywords:
      "Cyber Cases",

    helmetnoscript:
      "Please enable JavaScript to view this Cyber Matters service page properly.",
  },
  {
    id: "labor-law",
    title: "Labor Law",
    bannerImage: commercialimg2,
    shortDesc:
      "Expert legal assistance for employment disputes, workplace rights and labor compliance matters.",
    fullDesc: {
      intro:
        "We provide comprehensive labor  and employment law services for employees, employers, businesses and organizations. Our team offers legal guidance on workplace disputes, employment contracts, labor compliance, employee rights, wrongful termination and industrial relations matters.",

      sections: [
        {
          title: "Our Legal Expertise",
          content:
            "Our labor law practice focuses on protecting the rights of both employers  and employees while ensuring compliance with labor regulations. We provide strategic legal solutions for workplace disputes, employment issues and labor law compliance matters.",
        },

        {
          title: "Employment Contracts",
          list: [
            "Drafting  and reviewing employment agreements",
            "Executive  and management contracts",
            "Non-compete  and confidentiality clauses",
            "Employment policy development",
            "Contract dispute resolution",
          ],
        },

        {
          title: "Workplace Disputes",
          list: [
            "Employee-employer disputes",
            "Workplace harassment complaints",
            "Discrimination  and unfair treatment cases",
            "Disciplinary proceedings",
            "Workplace grievance resolution",
          ],
        },

        {
          title: "Wrongful Termination & Dismissal",
          list: [
            "Unlawful termination claims",
            "Retrenchment  and layoff disputes",
            "Employment reinstatement matters",
            "Compensation  and damages claims",
            "Legal representation before labor authorities",
          ],
        },

        {
          title: "Labor Compliance",
          list: [
            "Compliance with labor laws  and regulations",
            "Minimum wage  and wage payment matters",
            "Provident Fund (PF) compliance",
            "ESI  and employee benefit compliance",
            "Workplace policy audits",
          ],
        },

        {
          title: "Industrial Relations",
          list: [
            "Trade union  and collective bargaining matters",
            "Industrial dispute resolution",
            "Strike  and lockout issues",
            "Negotiation between employers  and workers",
            "Representation before labor courts  and tribunals",
          ],
        },

        {
          title: "Employee Rights Protection",
          list: [
            "Salary  and wage recovery claims",
            "Maternity  and employee benefit rights",
            "Workplace safety  and health issues",
            "Protection against unfair labor practices",
            "Legal remedies for employee grievances",
          ],
        },

        {
          title: "Why Choose Us",
          content:
            "Our experienced labor law team provides practical legal solutions tailored to workplace challenges. We focus on protecting rights, ensuring compliance and resolving disputes efficiently while minimizing risks for employers  and employees alike.",
        },

        {
          title: "Who We Help",
          list: [
            "Employees  and workers",
            "Employers  and business owners",
            "Corporate organizations",
            "Human resource departments",
            "Trade unions  and worker associations",
          ],
        },
      ],
    },
    icon: "⚖️",
    featureDetails: [
      {
        name: "Employment Contracts",
        img: commercialimg1,
        desc: "Drafting, reviewing and negotiating employment agreements.",
      },
      {
        name: "Wrongful Termination",
        img: commercialimg2,
        desc: "Legal representation in unfair dismissal  and termination disputes.",
      },
      {
        name: "Workplace Disputes",
        img: commercialimg3,
        desc: "Resolving conflicts between employers  and employees.",
      },
      {
        name: "Wages & Benefits",
        img: commercialimg4,
        desc: "Assistance with salary disputes, benefits and compensation claims.",
      },
      {
        name: "Labor Compliance",
        img: commercialimg5,
        desc: "Ensuring businesses comply with labor laws  and employment regulations.",
      },
      {
        name: "Workplace Harassment",
        img: commercialimg6,
        desc: "Legal support in cases involving harassment  and discrimination.",
      },
      {
        name: "Industrial Relations",
        img: commercialimg7,
        desc: "Advising on union matters, collective bargaining and labor relations.",
      },
      {
        name: "Employee Rights",
        img: commercialimg8,
        desc: "Protecting employee rights  and ensuring fair workplace practices.",
      },
    ],
    helmetTitle: "Labor Law Lawyers in Delhi NCR | Employment Experts",
    helmetDescription:
      "R & P Law Partners offers trusted Labor Law services in Delhi NCR for employers and employees, covering workplace disputes and legal compliance.",
    helmetKeywords:
      "Labor Law",
    helmetnoscript:
      "Please enable JavaScript to view this Labor Law service page properly.",
  },
  {
    id: "negotiable-instrument-act-cases",

    title: "Negotiable Instrument Act Cases",

    bannerImage: ibcimg1,

    shortDesc:
      "Expert legal services for cheque bounce  and financial disputes under the Negotiable Instruments Act.",

    fullDesc: {
      intro:
        "We provide comprehensive legal assistance in matters related to cheque dishonor under the Negotiable Instruments Act, 1881. Our team ensures swift legal action, proper documentation and strong representation to secure financial recovery  and protect client interests.",

      sections: [
        {
          title: "Our Legal Expertise",
          content:
            "Our practice focuses on h andling cheque bounce cases under Section 138 of the NI Act, along with related civil recovery proceedings. We ensure strict compliance with legal timelines  and procedures to maximize the chances of successful recovery.",
        },

        {
          title: "Cheque Bounce Cases",
          list: [
            "Filing complaints under Section 138 NI Act",
            "H andling multiple cheque dishonor cases",
            "Ensuring compliance with legal timelines",
            "Representation before Magistrate Courts",
            "Legal strategy for faster case resolution",
          ],
        },

        {
          title: "Legal Notice & Documentation",
          list: [
            "Drafting statutory legal notices",
            "Verification of cheque  and bank documents",
            "Preparation of complaint  and affidavits",
            "Evidence collection  and documentation",
            "Ensuring proper legal compliance",
          ],
        },

        {
          title: "Recovery & Compensation",
          list: [
            "Recovery of cheque amount with interest",
            "Interim compensation applications",
            "Settlement  and negotiation strategies",
            "Execution of court orders",
            "Financial claim enforcement",
          ],
        },

        {
          title: "Defense & Legal Protection",
          list: [
            "Defense in false cheque bounce cases",
            "Challenging invalid legal notices",
            "Legal representation for accused persons",
            "H andling misuse of NI Act provisions",
            "Appeals  and revision petitions",
          ],
        },

        {
          title: "Our Approach",
          list: [
            "Case evaluation  and document analysis",
            "Issuing legal notice within time limits",
            "Filing complaint  and legal proceedings",
            "Strong courtroom representation",
            "Exploring settlement opportunities",
            "Ensuring final recovery  and enforcement",
          ],
        },

        {
          title: "Why Choose Us",
          content:
            "We focus on fast  and effective recovery through strong legal action under the NI Act. Our team ensures proper h andling of documentation, timely filings and strategic representation to achieve the best possible outcome.",
        },

        {
          title: "Who We Help",
          list: [
            "Individuals facing cheque bounce issues",
            "Businesses dealing with payment defaults",
            "Vendors  and service providers",
            "Financial lenders  and institutions",
            "Clients involved in financial disputes",
          ],
        },
      ],
    },

    icon: "📄",

    featureDetails: [
      {
        name: "Legal Notice",
        img: ibcimg1,
        desc: "Drafting statutory notice within 15 days of cheque dishonor. We ensure compliance with all legal requirements.",
      },
      {
        name: "Sec 138 Complaint",
        img: ibcimg2,
        desc: "Filing criminal complaints in court. We h andle complete legal procedures efficiently.",
      },
      {
        name: "Cheque Bounce Cases",
        img: ibcimg3,
        desc: "H andling single  and multiple dishonor cases. We ensure strong legal representation.",
      },
      {
        name: "Evidence Support",
        img: ibcimg4,
        desc: "Preparing bank memos  and legal documents. We build a strong evidentiary base.",
      },
      {
        name: "Interim Compensation",
        img: ibcimg5,
        desc: "Securing interim compensation during trial. We help clients get early financial relief.",
      },
      {
        name: "Settlement Support",
        img: ibcimg6,
        desc: "Negotiating settlements between parties. We aim for quick  and practical resolution.",
      },
      {
        name: "Defense Counsel",
        img: ibcimg7,
        desc: "Representing accused in cheque bounce cases. We ensure fair legal defense.",
      },
      {
        name: "Appeals",
        img: ibcimg8,
        desc: "H andling appeals  and revisions. We ensure continued legal protection.",
      },
    ],

    helmetTitle:
      "Negotiable Instrument Act Cases in Delhi NCR | R & P Law",

    helmetDescription:
      "R & P Law Partners specializes in Negotiable Instrument Act Cases in Delhi NCR, handling cheque bounce disputes and effective legal recovery solutions.",

    helmetKeywords:
      "Negotiable Instrument Act Cases",

    helmetnoscript:
      "Please enable JavaScript to view this Negotiable Instrument Act service page properly.",
  },
  {
    id: "intellectual-property-rights",
    title: "Intellectual Property Rights (IPR)",
    bannerImage: commercialimg2,
    shortDesc:
      "Comprehensive legal protection for trademarks, copyrights, patents, designs and intellectual property assets.",

    fullDesc: {
      intro:
        "We provide end-to-end legal services in Intellectual Property Rights (IPR), helping individuals, startups, businesses and organizations protect, manage and enforce their intellectual assets. Our team assists with registration, licensing, infringement disputes and strategic IP protection across various industries.",

      sections: [
        {
          title: "Our Legal Expertise",
          content:
            "Our Intellectual Property Rights practice focuses on safeguarding innovations, creative works, brands and business assets. We provide strategic legal solutions for registration, enforcement, licensing and dispute resolution related to intellectual property.",
        },

        {
          title: "Trademark Services",
          list: [
            "Trademark search and availability analysis",
            "Trademark registration and filing",
            "Trademark renewal services",
            "Trademark opposition proceedings",
            "Trademark infringement protection",
          ],
        },

        {
          title: "Copyright Protection",
          list: [
            "Copyright registration",
            "Protection of literary and artistic works",
            "Software and digital content copyright",
            "Copyright licensing agreements",
            "Copyright infringement actions",
          ],
        },

        {
          title: "Patent Services",
          list: [
            "Patent filing and registration",
            "Patentability assessment",
            "Patent drafting and documentation",
            "Patent infringement disputes",
            "Patent licensing and commercialization",
          ],
        },

        {
          title: "Industrial Designs",
          list: [
            "Design registration",
            "Protection of product designs",
            "Design infringement matters",
            "Design licensing agreements",
            "Industrial design portfolio management",
          ],
        },

        {
          title: "IP Licensing & Commercialization",
          list: [
            "Intellectual property licensing agreements",
            "Technology transfer agreements",
            "Franchise and brand licensing",
            "Royalty and commercialization strategies",
            "IP assignment agreements",
          ],
        },

        {
          title: "IP Dispute Resolution",
          list: [
            "Trademark infringement litigation",
            "Copyright infringement disputes",
            "Patent enforcement actions",
            "Cease and desist notices",
            "Alternative dispute resolution for IP matters",
          ],
        },

        {
          title: "Why Choose Us",
          content:
            "Our experienced IPR team provides practical, business-focused solutions to protect and maximize the value of intellectual assets. We combine legal expertise with strategic guidance to help clients secure and enforce their rights effectively.",
        },

        {
          title: "Who We Help",
          list: [
            "Startups and entrepreneurs",
            "Artists and content creators",
            "Technology companies",
            "Manufacturers and businesses",
            "Corporations and brand owners",
          ],
        },
      ],
    },

    icon: "💡",

    featureDetails: [
      {
        name: "Trademark Registration",
        img: commercialimg1,
        desc: "Protect your brand identity through trademark registration and enforcement.",
      },
      {
        name: "Copyright Protection",
        img: commercialimg2,
        desc: "Secure legal rights for creative, artistic and digital works.",
      },
      {
        name: "Patent Registration",
        img: commercialimg3,
        desc: "Protect inventions and innovations through patent filing and registration.",
      },
      {
        name: "Industrial Designs",
        img: commercialimg4,
        desc: "Safeguard unique product designs and visual appearances.",
      },
      {
        name: "IP Licensing",
        img: commercialimg5,
        desc: "Drafting and negotiating intellectual property licensing agreements.",
      },
      {
        name: "Technology Transfer",
        img: commercialimg6,
        desc: "Legal support for technology transfer and commercialization deals.",
      },
      {
        name: "IP Litigation",
        img: commercialimg7,
        desc: "Representation in trademark, copyright and patent infringement disputes.",
      },
      {
        name: "Brand Protection",
        img: commercialimg8,
        desc: "Comprehensive legal strategies to protect business brands and reputation.",
      },
    ],

    helmetTitle:
      "Intellectual Property Rights Lawyers Delhi NCR | R & P Law",

    helmetDescription:
      "Protect your Intellectual Property Rights with R & P Law Partners, offering patent, copyright, trademark, licensing, and IP litigation services in Delhi NCR.",

    helmetKeywords:
      "Intellectual Property Rights",

    helmetnoscript:
      "Please enable JavaScript to view this Intellectual Property Rights (IPR) service page properly.",
  },
  {
  id: "copyright-trademark",
  title: "Copyright & Trademark",
  bannerImage: commercialimg2,
  shortDesc:
    "Comprehensive legal services for copyright protection, trademark registration, brand protection, intellectual property enforcement and dispute resolution.",

  fullDesc: {
    intro:
      "We provide end-to-end legal assistance in Copyright and Trademark matters, helping individuals, startups, businesses and organizations protect their intellectual property rights. Our team offers strategic guidance on registration, licensing, enforcement, infringement actions and brand protection to safeguard valuable creative works and business identities.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our intellectual property practice focuses on protecting creative works, trademarks, brands and business assets. We assist clients with registration, portfolio management, infringement disputes, licensing agreements and representation before intellectual property authorities and courts.",
      },

      {
        title: "Trademark Registration & Protection",
        list: [
          "Trademark search and availability assessment",
          "Trademark registration applications",
          "Brand name and logo protection",
          "Trademark portfolio management",
          "Trademark renewal and maintenance",
        ],
      },

      {
        title: "Copyright Protection",
        list: [
          "Copyright registration",
          "Protection of literary and artistic works",
          "Software and digital content protection",
          "Music, film and media copyright matters",
          "Copyright ownership and assignment advisory",
        ],
      },

      {
        title: "Brand Protection Services",
        list: [
          "Brand strategy and protection",
          "Monitoring unauthorized use of trademarks",
          "Domain name disputes",
          "Online brand protection",
          "Counterfeit product enforcement",
        ],
      },

      {
        title: "IP Litigation & Enforcement",
        list: [
          "Trademark infringement actions",
          "Copyright infringement disputes",
          "Cease and desist notices",
          "Civil and criminal enforcement proceedings",
          "Injunction and damages claims",
        ],
      },

      {
        title: "Licensing & Commercial Agreements",
        list: [
          "Trademark licensing agreements",
          "Copyright licensing arrangements",
          "Assignment and transfer agreements",
          "Franchise and brand usage agreements",
          "Intellectual property commercialization",
        ],
      },

      {
        title: "Opposition & Rectification Proceedings",
        list: [
          "Trademark opposition matters",
          "Trademark cancellation proceedings",
          "Rectification applications",
          "Response to examination reports",
          "Representation before IP authorities",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "Our legal team combines extensive knowledge of intellectual property laws with practical business insight. We provide strategic solutions to protect brands, creative works and commercial interests while ensuring effective enforcement and long-term value creation for our clients.",
      },

      {
        title: "Who We Help",
        list: [
          "Startups and entrepreneurs",
          "Corporates and business owners",
          "Artists, authors and creators",
          "Technology and software companies",
          "Media, entertainment and e-commerce businesses",
        ],
      },
    ],
  },

  icon: "©️",

  featureDetails: [
    {
      name: "Trademark Registration",
      img: commercialimg1,
      desc: "Assistance with trademark searches, filings and registration procedures.",
    },
    {
      name: "Copyright Registration",
      img: commercialimg2,
      desc: "Protecting creative works through copyright registration and legal advisory.",
    },
    {
      name: "Brand Protection",
      img: commercialimg3,
      desc: "Safeguarding business brands, logos and trade identities from misuse.",
    },
    {
      name: "Trademark Infringement",
      img: commercialimg4,
      desc: "Legal action against unauthorized use of registered trademarks.",
    },
    {
      name: "Copyright Enforcement",
      img: commercialimg5,
      desc: "Protecting original works against infringement and unauthorized reproduction.",
    },
    {
      name: "Licensing Agreements",
      img: commercialimg6,
      desc: "Drafting and reviewing copyright and trademark licensing arrangements.",
    },
    {
      name: "Opposition Proceedings",
      img: commercialimg7,
      desc: "Representation in trademark opposition, cancellation and rectification matters.",
    },
    {
      name: "IP Litigation",
      img: commercialimg8,
      desc: "Comprehensive representation in intellectual property disputes and enforcement actions.",
    },
  ],

  helmetTitle:
    "Copyright Trademark Lawyers in Delhi NCR | R & P Law",

  helmetDescription:
    "R & P Law Partners provides expert Copyright Trademark registration, protection, enforcement, and legal advisory services throughout Delhi NCR.",

  helmetKeywords:
    "Copyright Trademark",

  helmetnoscript:
    "Please enable JavaScript to view this Copyright & Trademark service page properly.",
},
  {
    id: "real-estate-regulatory-authority",
    title: "Real Estate",
    bannerImage: commercialimg2,
    shortDesc:
      "Expert legal assistance for real estate disputes, RERA compliance, project registration and property-related matters.",
    fullDesc: {
      intro:
        "We provide comprehensive legal assistance in matters related to the Real Estate Regulatory Authority (RERA), helping homebuyers, investors, builders, developers and real estate agents protect their rights  and ensure compliance with real estate laws. Our team offers strategic guidance for RERA registrations, disputes, complaints and regulatory compliance.",

      sections: [
        {
          title: "Our Legal Expertise",
          content:
            "Our RERA practice focuses on safeguarding the interests of homebuyers, developers and real estate stakeholders. We provide legal support in project registration, regulatory compliance, dispute resolution, delayed possession claims and representation before RERA authorities  and appellate tribunals.",
        },

        {
          title: "RERA Registration & Compliance",
          list: [
            "Project registration under RERA",
            "Real estate agent registration",
            "Regulatory compliance advisory",
            "Documentation  and disclosure requirements",
            "Legal support for developers  and builders",
          ],
        },

        {
          title: "Homebuyer Protection",
          list: [
            "Delayed possession claims",
            "Refund  and compensation claims",
            "Builder-buyer disputes",
            "Defective construction complaints",
            "Protection of consumer rights",
          ],
        },

        {
          title: "Builder & Developer Services",
          list: [
            "Compliance with RERA regulations",
            "Project documentation review",
            "Legal risk assessment",
            "Contract  and agreement drafting",
            "Regulatory advisory services",
          ],
        },

        {
          title: "RERA Complaints & Litigation",
          list: [
            "Filing complaints before RERA authorities",
            "Representation in RERA proceedings",
            "Dispute resolution  and settlements",
            "Appeals before RERA Appellate Tribunal",
            "Enforcement of RERA orders",
          ],
        },

        {
          title: "Property & Investment Disputes",
          list: [
            "Real estate investment disputes",
            "Misrepresentation by developers",
            "Agreement violations",
            "Property possession disputes",
            "Financial  and contractual claims",
          ],
        },

        {
          title: "Documentation & Legal Review",
          list: [
            "Builder-buyer agreement review",
            "Sale deed  and conveyance review",
            "Project approval verification",
            "Title  and ownership verification",
            "Legal due diligence services",
          ],
        },

        {
          title: "Why Choose Us",
          content:
            "Our legal team possesses extensive knowledge of RERA regulations  and real estate laws. We provide practical  and result-oriented solutions to protect our clients' investments, ensure compliance and resolve disputes efficiently through negotiation, litigation and regulatory proceedings.",
        },

        {
          title: "Who We Help",
          list: [
            "Homebuyers  and property investors",
            "Builders  and developers",
            "Real estate agents  and brokers",
            "Housing societies  and associations",
            "Commercial  and residential property owners",
          ],
        },
      ],
    },
    icon: "🏢",
    featureDetails: [
      {
        name: "Project Registration",
        img: commercialimg1,
        desc: "Assistance with RERA registration for real estate projects  and agents.",
      },
      {
        name: "Builder-Buyer Disputes",
        img: commercialimg2,
        desc: "Legal representation in disputes between developers  and property purchasers.",
      },
      {
        name: "Delayed Possession Claims",
        img: commercialimg3,
        desc: "Helping buyers seek remedies for delays in property h andover.",
      },
      {
        name: "Compensation Claims",
        img: commercialimg4,
        desc: "Pursuing compensation for project delays  and regulatory violations.",
      },
      {
        name: "RERA Compliance",
        img: commercialimg5,
        desc: "Advising developers  and agents on compliance with RERA regulations.",
      },
      {
        name: "Project Documentation",
        img: commercialimg6,
        desc: "Reviewing  and verifying legal  and regulatory property documents.",
      },
      {
        name: "RERA Appeals",
        img: commercialimg7,
        desc: "Representation before RERA Appellate Tribunals  and higher forums.",
      },
      {
        name: "Homebuyer Protection",
        img: commercialimg8,
        desc: "Safeguarding the rights  and interests of homebuyers  and investors.",
      },
    ],
    helmetTitle:
      "Real Estate Regulatory Authority Lawyers Delhi NCR | R & P Law",
    helmetDescription:
      "R & P Law Partners offers legal assistance for Real Estate Regulatory Authority matters in Delhi NCR, including RERA disputes and builder litigation.",
    helmetKeywords:
      "Real Estate Regulatory Authority",
    helmetnoscript:
      "Please enable JavaScript to view this Real Estate Regulatory Authority (RERA) service page properly.",
  },

  
];
